"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUpcomingCharge = exports.getLawFirmData = exports.unsubscribe = exports.subscribe = exports.getSubscription = exports.getList = exports.setUpcomingCharge = exports.setLawFirmData = exports.toggleMobileInfoModal = exports.toggleSubscribeModal = exports.toggleSuccessModal = exports.resetState = exports.setSubscription = exports.setList = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const userSlice_1 = require("./userSlice");
const store_1 = __importDefault(require("../store"));
const initialState = {
    invoices: [],
    subscription: null,
    toggleModal: false,
    toggleSubModal: false,
    toggleMobileModal: false,
    modalTitle: '',
    upcomingCharge: 0,
    quantity: 0,
    hasCustomerId: null,
    trial: false,
    price: 7.95,
    trialDays: 14
};
let isSubscribing = false;
const subscription = toolkit_1.createSlice({
    name: 'subscription',
    initialState: initialState,
    reducers: {
        setSubscription: (state, action) => {
            state.subscription = action.payload;
            return state;
        },
        setList: (state, action) => {
            state.invoices = action.payload;
            return state;
        },
        setLawFirmData: (state, action) => {
            state.quantity = action.payload.quantity;
            state.hasCustomerId = !!action.payload.customerId;
            return state;
        },
        setUpcomingCharge: (state, action) => {
            state.upcomingCharge = action.payload || (state.quantity * state.price).toFixed(2);
            return state;
        },
        resetState: (state) => {
            return initialState;
        },
        toggleSuccessModal: (state, action) => {
            state.toggleModal = !state.toggleModal;
            state.modalTitle = action.payload;
            return state;
        },
        toggleSubscribeModal: (state, action) => {
            state.toggleSubModal = !state.toggleSubModal;
            state.trial = action.payload;
            return state;
        },
        toggleMobileInfoModal: (state, action) => {
            state.toggleMobileModal = !state.toggleMobileModal;
            return state;
        }
    }
});
_a = subscription.actions, exports.setList = _a.setList, exports.setSubscription = _a.setSubscription, exports.resetState = _a.resetState, exports.toggleSuccessModal = _a.toggleSuccessModal, exports.toggleSubscribeModal = _a.toggleSubscribeModal, exports.toggleMobileInfoModal = _a.toggleMobileInfoModal, exports.setLawFirmData = _a.setLawFirmData, exports.setUpcomingCharge = _a.setUpcomingCharge;
const getList = () => async (dispatch) => {
    try {
        const items = await api_1.Subscription.getInvoices({});
        dispatch(exports.setList(items.data));
        return items;
    }
    catch (e) {
        console.error(`Can't fetch list with error`, e);
        return null;
    }
};
exports.getList = getList;
const getSubscription = () => async (dispatch) => {
    try {
        const subscription = (await api_1.Subscription.getSubscription()).data;
        dispatch(exports.setSubscription(subscription));
    }
    catch (e) {
        console.log('e', e);
    }
};
exports.getSubscription = getSubscription;
const subscribe = (trial = false) => async (dispatch) => {
    var _a, _b;
    try {
        if (isSubscribing)
            return;
        isSubscribing = true;
        await api_1.Subscription.subscribe({ trial });
        dispatch(exports.toggleSubscribeModal(false));
        dispatch(exports.toggleSuccessModal('You have successfully subscribed.'));
        dispatch(updateSubscription());
        dispatch(exports.getList());
        isSubscribing = false;
        window.AppearMe.Widgets.Events.emit('subscriptionUpdate', { subscribed: true });
    }
    catch (e) {
        if (((_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) === 'Payment is Missing') {
            dispatch(userSlice_1.getUser());
            const user = store_1.default.getState().user;
            window.location.href = `#/${user.roleId === 3 ? 'payment-history' : 'payment'}?showCardForm=true`;
        }
        isSubscribing = false;
        console.log('e', e);
    }
};
exports.subscribe = subscribe;
const unsubscribe = () => async (dispatch) => {
    try {
        await api_1.Subscription.unsubscribe();
        dispatch(exports.toggleSuccessModal('You have successfully unsubscribed.'));
        dispatch(updateSubscription());
        dispatch(exports.getList());
        window.AppearMe.Widgets.Events.emit('subscriptionUpdate', { subscribed: false });
    }
    catch (e) {
        console.error('cant unsubscribe with error', e);
    }
};
exports.unsubscribe = unsubscribe;
const getLawFirmData = () => async (dispatch) => {
    try {
        const count = await api_1.Subscription.getLawFirmData();
        return dispatch(exports.setLawFirmData(count.data));
    }
    catch (e) {
        console.log('e', e);
    }
};
exports.getLawFirmData = getLawFirmData;
const getUpcomingCharge = () => async (dispatch) => {
    try {
        const charge = await api_1.Subscription.getUpcomingCharge();
        return dispatch(exports.setUpcomingCharge(charge.data));
    }
    catch (e) {
        console.error(`Can't fetch upcoming invoice error`, e);
        dispatch(exports.setUpcomingCharge(null));
    }
};
exports.getUpcomingCharge = getUpcomingCharge;
const updateSubscription = () => async (dispatch) => {
    try {
        const userSubscription = (await api_1.Subscription.getSubscription()).data;
        dispatch(exports.setSubscription(userSubscription));
    }
    catch (e) {
        console.log('e', e);
    }
};
exports.default = subscription.reducer;
